import { makeStyles, Theme } from '@material-ui/core/styles'

const useStyles = makeStyles((theme: Theme) => ({
  rootPaper: {
    width: 796,
    borderRadius: '0 0 9px 9px',
    backgroundColor: theme.palette.background.default,
    [theme.breakpoints.down('lg')]: {
      boxShadow: '0 2px 13px 0 rgba(0, 0, 0, 0.1)'
    },
    [theme.breakpoints.down('md')]: {
      width: 740
    },
    [theme.breakpoints.between('sm', 'md')]: {
      width: 460,
      // width: '100%',
      border: '1px solid #f1cdcd'
    },
    [theme.breakpoints.down('xs')]: {
      width: '100vw !important',
      height: '100%',
      right: 0,
      left: 0,
      bottom: 0,
      position: 'fixed',
      zIndex: 2
    },
    [theme.breakpoints.between(600, 960)]: {
      width: '100vw !important',
      height: '100%',
      right: 0,
      left: 0,
      bottom: 0,
      position: 'fixed',
      zIndex: 2
    }
  },
  hiddenPaper: {
    paddingBottom: 0,
    border: 'none',
    display: 'none'
  },
  infoBox: {
    width: 796,
    height: 86,
    borderRadius: 9,
    boxShadow: '0 2px 13px 0 rgba(0, 0, 0, 0.17)',
    backgroundColor: '#ffffff',
    paddingLeft: 71,
    paddingTop: 12,
    [theme.breakpoints.down('md')]: {
      width: 740
    },
    [theme.breakpoints.between('sm', 'md')]: {
      width: 460
    },
    [theme.breakpoints.down('sm')]: {
      width: '100vw'
    }
  },
  bigInfoBox: {
    paddingLeft: 30
  },
  datePickerAppBar: {
    [theme.breakpoints.between('sm', 'md')]: {
      borderTopLeftRadius: 9,
      borderTopRightRadius: 9
    },
    [theme.breakpoints.down('sm')]: {
      marginTop: 60,
      width: '100vw'
    }
  },
  pickedDateBox: {
    width: 130
  },
  bigPickedDateBox: {
    width: 180
  },
  checkOutBox: {
    flex: 1
  },
  nightsCounterGrid: {
    marginTop: 31,
    marginRight: 67,
    marginBottom: 15,
    display: 'flex',
    alignItems: 'flex-end'
  },
  nightsCounterGridMobile: {
    flex: 1,
    display: 'flex',
    alignItems: 'flex-end'
  },
  nightsCounterDigit: {
    fontSize: 22,
    lineHeight: 1,
    paddingRight: 6
  },
  nightsCounterText: {
    lineHeight: 1
  },
  calendarMainGrid: {
    paddingTop: 20,
    width: 732,
    height: 387,
    margin: 'auto',
    marginTop: 16,
    overflow: 'hidden',
    [theme.breakpoints.between('sm', 'md')]: {
      width: 460
    },
    [theme.breakpoints.down('sm')]: {
      width: '100vw !important',
      height: 'fill-available',
      overflowY: 'scroll',
      marginLeft: -10,
      marginBottom: 77
    },
    [theme.breakpoints.between(600, 960)]: {
      width: '100vw !important',
      height: '60%',
      overflowY: 'scroll',
      marginLeft: -10,
      marginBottom: 40
    }
  },
  calendarButtonsGrid: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: 60,
    width: 663,
    padding: '10px 0',
    margin: 'auto',
    [theme.breakpoints.between('sm', 'md')]: {
      width: 400
    },
    [theme.breakpoints.down('xs')]: {
      width: '100% !important',
      padding: '0px 25px 8px',
      boxShadow: '0 -5px 5px -5px #333',
      height: 58,
      position: 'fixed',
      bottom: 0,
      background: 'white'
    },
    [theme.breakpoints.between(600, 960)]: {
      width: '100%',
      justifyContent: 'space-around'
    }
  },
  calendarButtonsGridForOneMonth: {
    width: 293
  },
  calendarGridButton: {
    fontSize: 15,
    cursor: 'pointer'
  },
  GoToTodayButton: {
    fontSize: 15,
    cursor: 'pointer',
    color: `${theme.palette.primary.contrastText}!important`
  },
  calendarResetButtonGrid: {
    marginRight: 34
  },
  datePickerBoxTab: {
    width: '50%',
    [theme.breakpoints.between(600, 960)]: {
      maxWidth: '100%'
    }
  },
  paperWithoutShadow: {
    boxShadow: 'none',
    border: '1px solid #dfdfdf',
    overflowX: 'hidden'
  },
  daysContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: 663,
    padding: '10px 0',
    margin: 'auto',
    [theme.breakpoints.between('sm', 'md')]: {
      width: 400
    },
    [theme.breakpoints.down('xs')]: {
      width: '100% !important',
      padding: '0px 25px 8px',
      boxShadow: '0 -5px 5px -5px #333',
      height: 58,
      position: 'fixed',
      bottom: 0,
      background: 'white'
    }
  },
  border: {
    background: theme.palette.grey[300],
    width: '100%',
    height: 1,
    marginBottom: 20
  },
  weekDayBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 10,
    background: theme.palette.grey[200],
    cursor: 'pointer',
    border: '1px solid transparent'
  },
  weekDayBoxWithBorder: {
    border: `1px solid ${theme.palette.grey[800]}`,
    boxSizing: 'border-box'
  },
  weekDaysContainer: {
    margin: '10px 0px',
    display: 'grid',
    gridTemplateColumns: 'repeat(7,1fr)',
    gap: 8
  },
  dayTitles: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  paperWithScroll: {
    height: 350,
    overflowY: 'auto'
  }
}))

export default useStyles
